import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const OccurrenceInfo = ({data, occData}) => {

    const info = [
        {
            label: "Cadastrada em",
            value: data?.system_dt_create ?? "",
        },
        {
            label: "Cadastrada por",
            value: data?.user_create_name ?? "",
            span: 2
        },
        {
            label: "Município responsável",
            value: occData?.cityOwner ?? "",
        },
        {
            label: "Visibilidade",
            value: data?.system_visibility,
        },
        {
            label: "Status",
            value: occData?.status?.status,
        },
        {
            label: "D/H do fato",
            value: data?.systemDtText ?? ""
        },
        {
            label: "Flagrante",
            value: occData?.flagrant ? "Sim" : "Não",
        }
    ]

    const placeInfo = [
        {
            subTitle: "Endereço",
            items: [
                {
                    label: "Local pré-cadastrado",
                    value: occData.local?.place,
                    span: 2
                },
                {
                    label: "Tipo do local",
                    value: occData.local?.type ?? "",
                },
                {
                    label: "Logradouro",
                    value: occData.local?.address?.replace(",", ", ") ?? "",
                    span: 2
                },
                {
                    label: "Número",
                    value: occData.local?.number ?? "",
                },
                {
                    label: "Bairro",
                    value: occData.local?.neighborhood ?? "",
                },
                {
                    label: "Complemento",
                    value: occData.local?.complement ?? "",
                },
                {
                    label: "Município",
                    value: occData.local?.city ?? "",
                },
                {
                    label: "CEP",
                    value: occData.local?.zipCode ?? "",
                },
                {
                    label: "Latitude",
                    value: occData.local?.latitude ?? "",
                },
                {
                    label: "Longitude",
                    value: occData.local?.longitude ?? "",
                }
            ]
        }
    ]

    const contactInfo = [
        {
            subTitle: "Contato",
            items: [
                {
                    label: "CPF/CNPJ do contato",
                    value: projectUtils.formatCpfCnpjToView(occData?.cpfCnpjContact) ?? "",
                },
                {
                    label: "Telefone do contato",
                    value: occData?.contactPhone ?? "",
                },
                {
                    label: "Nome do contato",
                    value: occData?.contactName ?? "",
                }
            ]
        }
    ];

    const occurrenceRelated = (occData?.relatedOccurrences ?? [])
        .map(item => item?.occurrenceId)
        .filter(Boolean)
        .join(", ");

    const boRelated = (occData?.bos ?? [])
        .map(item => [item?.type, item?.name].filter(Boolean).join(" - ").replaceAll(";", ""))
        .filter(Boolean)
        .join(", ");

    const otherInfo = [
        {
            subTitle: "Outras informações",
            items: [
                {
                    label: "Apresentado por",
                    value: occData?.presentedBy ?? "",
                },
                ...(boRelated ? [{
                    label: "Boletim",
                    value: boRelated,
                }] : []),
                ...(occurrenceRelated ? [{
                    label: "Ocorrência relacionada",
                    value: occurrenceRelated,
                }] : [])
            ]
        }
    ];

    const descriptionInfo = [
        {
            subTitle: "Descrição",
            items: [
                {
                    label: null,
                    value: occData?.description ?? "",
                    valueClassName: 'ml-0!',
                    dots: false,
                    span: 3
                }
            ]
        }
    ];

    const inactivationInfo = [
        {
            subTitle: "Motivo de encerramento",
            items: [
                {
                    label: null,
                    value: occData?.status?.description ?? "",
                    valueClassName: 'ml-0!',
                    dots: false,
                    span: 3
                }
            ]
        }
    ];

    return (
        <>
            <section className={'px-5!'}>
                <h2 className="flex flex-row items-center justify-center w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]!">
                    DADOS DA OCORRÊNCIA
                </h2>
            </section>

            <InfoGrid title={''} items={info} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>

            { occData?.description && (
                <InfoGrid title={''} items={descriptionInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>
            )}

            <InfoGrid title={''} items={placeInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>

            <InfoGrid title={''} items={contactInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>

            <InfoGrid title={''} items={otherInfo} columns={1} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>

            { occData?.status?.description && (
                <InfoGrid title={''} items={inactivationInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>
            )}
        </>
    )
};

export default OccurrenceInfo;